<template>
  <div class="content-body">
    <LanguageSelector />
    <Alert v-if="error == 'error-message'" :text="errorText" type="danger" dismissable="false" />
    <section id="basic-datatable">
      <div class="row">
        <div class="col-12">
          <div class="text-right">
            <button type="button" class="btn btn-primary mb-1" @click="inviteUserModal()">
              <em class="bx bx-envelope"></em>
              <span class="align-middle ml-25">Invite User</span>
            </button>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-header">
                <h5 class="card-title">Manage Invites</h5>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <div class="has-icon-left">
                        <select class="form-control" v-model="typeFilter" @change="filterByData()">
                          <option selected>All Types...</option>
                          <option value="tenant">Tenants</option>
                          <option value="landlord">Landlords</option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-filter font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="has-icon-left">
                        <select class="form-control" v-model="countryFilter" @change="filterByData()">
                          <option selected>All Countries...</option>
                          <option v-for="(country, index) in usersCountries" :value="country" :key="index">{{
                          countryName(country) }}</option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-map font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="has-icon-left">
                        <input type="text" class="form-control" @keyup="searchInTable()" v-model="searchInputText"
                          placeholder="Search..." />
                        <div class="form-control-position">
                          <em class="bx bx-search font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body card-dashboard">
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div class="text-center mt-1" v-if="!invites.length && !loadingData">
                  <p>No Invites Found...</p>
                </div>
                <div class="table-responsive" v-if="invites.length">
                  <table class="table zero-configuration" :aria-label="$t('invites_aria_label_invite_list')">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone Number</th>
                        <th>Email</th>
                        <th>Type of user</th>
                        <th>Date of invitation</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(invite, index) in invites" :key="index">
                        <td class="inviteName">
                          <span class="nameSpan" v-if="invite.name">{{ invite.name }}</span>
                          <span class="nameSpan" v-else>-</span>
                          <br />
                          <a href="#" style="margin-top: 5px;" @click="deleteInvite(invite.uid)">
                            <em class="bx bx-trash"></em> Delete
                          </a>
                        </td>
                        <td v-if="invite.phoneNumber">{{ invite.phoneNumber }}</td>
                        <td v-else>-</td>
                        <td v-if="invite.email">{{ invite.email }}</td>
                        <td v-else>-</td>
                        <td class="capitalize">{{ invite.type }}</td>
                        <td>{{ invite.createdAt.split('T')[0] }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Invite User -->
    <div class="modal fade text-left" id="invite-user-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">Invite User</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x"></em>
            </button>
          </div>
          <div class="modal-body">
            <Alert v-if="error == 'required'"
              text="You have to put either <strong>Email</strong> or <strong>Phone Number</strong>" type="danger"
              dismissable="false" />
            <Alert v-if="error == 'error-message'" :text="errorText" type="danger" dismissable="false" />
            <form action="#">
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for>Name</label>
                  <input type="text" class="form-control" placeholder="John Doe" v-model="nameInvite" />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 col-sm-12" v-if="isSuperadmin">
                  <label for>Country</label>
                  <select v-model="countryInvite" class="form-control">
                    <option value="Choose..." selected disabled>Choose...</option>
                    <option v-for="(country, index) in activeCountries" :key="index" :value="country.toLowerCase()">{{
                    countryName(country) }}</option>
                  </select>
                </div>
                <div class="col-md-12 col-sm-12" v-else>
                  <label for>Country</label>
                  <select v-model="countryInvite" class="form-control" disabled>
                    <option value="Choose..." selected disabled>Choose...</option>
                    <option v-for="(country, index) in activeCountries" :key="index" :value="country.toLowerCase()">{{
                    countryName(country) }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for>Language</label>
                  <select class="form-control" v-model="languageInvite">
                    <option value="en">English</option>
                    <option value="ar">Arabic</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for>Type</label>
                  <select class="form-control" v-model="typeInvite">
                    <option value="landlord">Landlord</option>
                    <option value="tenant">Tenant</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for>Email</label>
                  <input type="text" class="form-control" placeholder="johndoe@example.com" v-model="emailInvite" />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>Phone Number</label>
                  <input type="tel" id="phoneNumber" class="form-control" v-model="invitePhoneNumber" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">Close</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="sendInvitation()">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">Send Invitation</span>
            </button>
          </div>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import { getLanguageName } from "@/app-assets/js/get-language.js";
import Alert from "@/components/Alerts";
export default {
  data() {
    return {
      invites: [],
      loadingData: true,
      usersCountries: [],
      countryFilter: "All Countries...",
      typeFilter: "All Types...",
      activeCountries: [],
      searchInputText: "",
      phoneNumberObj: null,
      invitePhoneNumber: "",
      nameInvite: "",
      emailInvite: "",
      countryInvite: "lb",
      languageInvite: "en",
      typeInvite: "landlord",
      error: "",
      errorText: "",
    };
  },

  components: {
    Alert
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    }
  },

  methods: {
    initDataTable() {
      let self = this;
      setTimeout(function () {
        $(".zero-configuration").DataTable({
          bLengthChange: false,
          bFilter: false,
          order: []
        });
      }, 100);
    },

    getInvites() {
      let self = this;
      self.loadingData = true;
      this.$apiCall.get("/v1/invites").then(response => {
        response.data.data.forEach(function (element) {
          if (
            !self.usersCountries.includes(element.country) &&
            element.country
          ) {
            self.usersCountries.push(element.country);
          }
        });
        self.loadingData = false;
        self.invites = response.data.data;
        self.initDataTable();
      });
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    langName(element) {
      if (element) {
        return getLanguageName(element);
      }
    },

    getActiveCountries() {
      const countries = localStorage.getItem('activeCountries');
      this.activeCountries = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
    },

    searchInTable() {
      var value = this.searchInputText.toLowerCase();
      $(".zero-configuration > tbody tr").filter(function () {
        $(this).toggle(
          $(this)
            .find(".inviteName > .nameSpan")
            .text()
            .toLowerCase()
            .indexOf(value) > -1
        );
      });
    },

    filterApiCall(data) {
      let self = this;
      self.$apiCall
        .get(`/v1/invites${data}`)
        .then(response => {
          self.loadingData = false;
          self.invites = response.data.data;
          self.initDataTable();
        })
    },
    filterByData() {
      let self = this;
      self.invites = [];
      self.loadingData = true;
      let data = [];
      if (self.countryFilter != "All Countries...") {
        data.push("country=" + self.countryFilter)
      }
      if (self.typeFilter != "All Types...") {
        data.push("type=" + self.typeFilter)
      }
      let query = '';
      if (data.length) {
        query = '?' + data.join('&');
        self.filterApiCall(query)
      } else {
        self.usersCountries = [];
        self.getInvites();
      }

    },

    initTelInput() {
      let input = document.querySelector("#phoneNumber");
      this.phoneNumberObj = intlTelInput(input);
    },

    inviteUserModal() {
      $("#invite-user-modal").modal();
    },
inviteSuccess(){
  $("#invite-success-modal").modal()
},
    sendInvitation() {

      let self = this;

      this.error = "";
      this.errorText = "";

      let countryData = this.phoneNumberObj.getSelectedCountryData();
      let pN = "+" + countryData.dialCode + this.invitePhoneNumber.replace(`+${countryData.dialCode}`, "");
      if (self.invitePhoneNumber != "" || self.emailInvite != "") {
        var block_ele = $("#invite-user-modal .modal-content");
        $(block_ele).block({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait"
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent"
          }
        });
        this.$apiCall
          .post("/v1/invites", {
            email: (self.emailInvite.trim() != "") ? self.emailInvite : null,
            name: self.nameInvite,
            phoneNumber: (self.invitePhoneNumber != "") ? pN : null,
            language: self.languageInvite,
            type: self.typeInvite,
            country: self.countryInvite
          })
          .then(response => {
            self.inviteSuccess()
            $(block_ele).unblock();
            self.invitePhoneNumber = "";
            self.nameInvite = "";
            self.emailInvite = "";
            self.languageInvite = "en";
            if (self.$store.state.currentUser.user.type == "superadmin") {
              self.countryInvite = "Choose...";
            } else {
              self.countryInvite = self.$store.state.currentUser.user.country;
            }
            self.typeInvite = "landlord";
            $("#invite-user-modal").modal("hide");
            self.inviteSuccess()


            self.invites = [];
            self.getInvites();

          })
          .catch(error => {

            if (error.response.status == 406) {
              self.error = "error-message";
              self.errorText = `Ops! These invitation data <strong>already exist</strong>`;
            } else if (error.response.status == 405) {
              self.error = "error-message";
              self.errorText = `<strong>Ops!</strong> User already exists`;
            } else {
              self.error = "error-message";
              self.errorText = `<strong>Ops!</strong> ${error.response.data.message}`;
            }

            $(block_ele).unblock();
          })
      } else {
        self.error = 'required';
      }
    },

    deleteInvite(uid) {
      this.error = ''
      this.errorText = ''
      let self = this;
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait"
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent"
        }
      });

      this.$apiCall.delete(`/v1/invites/${uid}`).then(() => {
        $.unblockUI();
        self.invites = [];
        self.getInvites();
      })
        .catch(error => {
          $.unblockUI();
          this.error = "error-message";
          this.errorText = `<strong>Ops!</strong> ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        })
    }
  },

  watch: {
    invitePhoneNumber: function (value) {
      this.invitePhoneNumber = value.replace(/[^\d|\-+]/g, '')
    }
  },

  mounted() {
    this.initTelInput();
    this.getInvites();
    this.getActiveCountries();

    if (this.$store.state.currentUser.user.type == "superadmin") {
      this.countryInvite = "Choose...";
    } else {
      this.countryInvite = this.$store.state.currentUser.user.country;
    }
  },

};
</script>

<style scoped>
.zero-configuration td {
  white-space: nowrap;
}
.heading-elements .list-inline li {
  margin-right: 5px;
}
</style>
